<template>
	<table class="responsive-table" :class="{last: maxed}">
		<thead v-if="$slots.header">
			<slot name="header"></slot>
		</thead>
		<slot></slot>
	</table>
</template>

<script>
	export default {
		props: ['priority'],
		data() {
			return {
				removed: [],
				maxed: false
			};
		},
		watch: {
			'$store.state.screenWidth': function() {
				this.calc();
			}
		},
		methods: {
			async calc(level) {
				if(!level) {
					this.maxed = false;
					this.removed = [];
					level = 0;
				}
				if(this.maxed) {
					return;
				}
				await this.$nextTick();
				let last = null;
				let found = false;
				this.$children.forEach((component) => {
					if(found || this.maxed) {
						return;
					}
					const cols = (component.$children || []).filter(x => x.$vnode.elm && x.$vnode.elm.nodeName === 'TD');
					if(cols.length === 1 || this.removed.length >= this.priority.length) {
						this.maxed = true;
						return;
					}
					cols.forEach(async (col) => {
						if(found) {
							return;
						}
						if(col.$vnode.elm.classList.contains('image-col')) {
							return;
						}
						const bounds = col.$vnode.elm.firstElementChild.getBoundingClientRect();
						if(last === null) {
							last = bounds.height;
							return;
						}
						if(bounds.height !== last) {
							this.removed.push(this.priority[level]);
							console.log(this.removed);
							found = true;
							await this.calc(level + 1);
						}
					})
				});
			}
		},
		async mounted() {
			await this.calc();
		}
	}
</script>